import {ActionReducerMapBuilder, createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {RootState} from "../../../../app/store";
import {APIError} from "../../../../services/HttpService";
import {deleteIgnoredUrl, getIgnoredUrls, addIgnoredUrl, IgnoredUrl} from "../../../../services/IgonreUrlService";
import {RejectError, RejectErrorType} from "../../../error/Error";

export interface IgnoredUrlsState {
  ignoredUrls: IgnoredUrl[];
}

const initialState: IgnoredUrlsState = {
  ignoredUrls: []
};

export const listIgnoredUrls = createAsyncThunk<IgnoredUrl[], {userId: number}, {rejectValue: RejectError}>(
  "ignoredUrls/list",
  async (action, {rejectWithValue}) => {
    try {
      return getIgnoredUrls(action.userId);
    } catch (error) {
      if (error instanceof APIError) return rejectWithValue({message: error.message, code: error.statusCode, type: RejectErrorType.API});

      throw error;
    }
  }
);

export const removeIgnoredUrl = createAsyncThunk<number, {userId: number; ignoredUrlId: number}, {rejectValue: RejectError}>(
  "ignoredUrls/remove",
  async (action, {rejectWithValue}) => {
    try {
      await deleteIgnoredUrl(action.userId, action.ignoredUrlId);
      return action.ignoredUrlId;
    } catch (error) {
      if (error instanceof APIError) return rejectWithValue({message: error.message, code: error.statusCode, type: RejectErrorType.API});
      throw error;
    }
  }
);

export const insertIgnoredUrl = createAsyncThunk<IgnoredUrl, {userId: number; type: string; pattern: string}>(
  "ignoredUrls/add",
  async (action) => {
    return addIgnoredUrl(action.userId, action.type, action.pattern);
  }
);

const extraReducers = (builder: ActionReducerMapBuilder<IgnoredUrlsState>) => {
  builder.addCase(listIgnoredUrls.fulfilled, (draft, action) => {
    draft.ignoredUrls = action.payload;
  });
  builder.addCase(removeIgnoredUrl.fulfilled, (draft, action) => {
    draft.ignoredUrls = draft.ignoredUrls.filter((i) => i.id !== action.payload);
  });
  builder.addCase(insertIgnoredUrl.fulfilled, (draft, action) => {
    draft.ignoredUrls = [...draft.ignoredUrls, action.payload];
  });
};

export const ignoreUrlsSlice = createSlice({
  name: "ignoredUrls",
  initialState,
  reducers: {},
  extraReducers
});

export const ignoredUrlsState = (state: RootState): IgnoredUrlsState => state.ignoredUrls;

export default ignoreUrlsSlice.reducer;
